module.exports = __webpack_public_path__ + "static/media/usability.2e1053ea.obj";